/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const CLAIM_ERROR_POPUP_MESSAGE = 'NOU_CLAIM_ERROR_POPUP_MESSAGE';
export const CLAIM_SUCCESS_MESSAGE = 'NOU_CLAIM_SUCCESS_MESSAGE';
export const CLAIM_SELECTED_NDC_TAB = 'NOU_CLAIM_SELECTED_NDC_TAB';

export const CLAIM_SEARCH_BY_DRUG_NAME_TABLE_DATA =
  'NOU_CLAIM_SEARCH_BY_DRUG_NAME_TABLE_DATA';
export const CLAIM_LABELER_TABLE_DATA = 'NOU_CLAIM_LABELER_TABLE_DATA';

export const CLAIM_LABELER_DRUG_TABLE_DATA = 'NOU_CLAIM_LABELER_DRUG_TABLE_DATA';
export const CLAIM_DETAILS_TABLE_DATA = 'NOU_CLAIM_DETAILS_TABLE_DATA';
export const CLAIM_DETAILS_TABLE_ROW_SELECTED =
  'NOU_CLAIM_DETAILS_TABLE_ROW_SELECTED';

export const CLAIM_LOADING = 'NOU_CLAIM_LOADING';
export const CLAIM_REFERENCE_DATA = 'NOU_CLAIM_REFERENCE_DATA';
export const CLAIM_PROVIDER_ID_TYPE_DROPDOWN =
  'NOU_CLAIM_PROVIDER_ID_TYPE_DROPDOWN';
export const CLAIM_CATEGORY_CODE_DROPDOWN = 'NOU_CLAIM_CATEGORY_CODE_DROPDOWN';
export const CLAIM_REBATE_PROGRAM_DROPDOWN = 'NOU_CLAIM_REBATE_PROGRAM_DROPDOWN';
export const CLAIM_CLIENT_DROPDOWN = 'NOU_CLAIM_CLIENT_DROPDOWN';
export const CLAIM_GROUP_DROPDOWN = 'NOU_CLAIM_GROUP_DROPDOWN';
export const CLAIM_PLAN_DROPDOWN = 'NOU_CLAIM_PLAN_DROPDOWN';

export const CLAIM_SELECT_BY_FILTER = 'NOU_CLAIM_SELECT_BY_FILTER';
export const CLAIM_GENERAL_PARAMETERS = 'NOU_CLAIM_GENERAL_PARAMETERS';
export const CLAIM_INVOICED_SELECTED = 'NOU_CLAIM_INVOICED_SELECTED';
export const CLAIM_REBATE_TYPE = 'NOU_CLAIM_REBATE_TYPE';
export const CLAIM_DETAILS_POPUP = 'NOU_CLAIM_DETAILS_POPUP';
export const CLAIM_SUPP_RADIO_DISABLE = 'NOU_CLAIM_SUPP_RADIO_DISABLE';

export const CLAIM_CATEGORY_CODE = 'NOU_CLAIM_CATEGORY_CODE';
export const ENTERED_NDC = 'NOU_ENTERED_NDC';
export const SET_DISABLED_BUTTON = 'NOU_SET_DISABLED_BUTTON';
export const DISPUTE_RESOLUTION_TOGGLE = 'NOU_DISPUTE_RESOLUTION_TOGGLE';

export const UNIT_LOADING = 'NOU_UNIT_LOADING';
export const UNIT_RESPONSE = 'NOU_UNIT_RESPONSE';

export const SET_EDITED_ROWS = 'NOU_SET_EDITED_ROWS';
export const RESET_EDITED_ROWS = 'NOU_RESET_EDITED_ROWS';
export const SET_ERROR_MESSAGE = 'NOU_SET_ERROR_MESSAGE';
export const SET_CLAIM_ID = 'NOU_SET_CLAIM_ID';

export const CLEAR_REDUX_DATA_CLAIM = 'NOU_CLEAR_REDUX_DATA_CLAIM';

// The rest (already unique) can stay as they are:
export const CUSTOM_NOU_CLAIM_TABLE_LOAD = 'CUSTOM_NOU_CLAIM_TABLE_LOAD';
export const NUMBER_OF_UNITS_SELECT_BY = 'NUMBER_OF_UNITS_SELECT_BY';
export const SELECTED_CLAIM_NU = 'SELECTED_CLAIM_NU';
export const SELECTED_CLAIM_INDEX = 'SELECTED_CLAIM_INDEX';
export const SELECTED_CLAIM_FILTER_NU = 'SELECTED_CLAIM_FILTER_NU';
export const SELECTED_CLAIM_MODE_NU = 'SELECTED_CLAIM_MODE_NU';
export const CLAIM_SELECTED_RECORD_INDEX = 'NOU_CLAIM_SELECTED_RECORD_INDEX';
export const RESET_SELECT_CLAIM_DATA_NU = 'RESET_SELECT_CLAIM_DATA_NU';
export const RESET_SELECTED_CLAIM_DATA = 'RESET_SELECTED_CLAIM_DATA';
export const SET_TABLE_DATA_NU = 'SET_TABLE_DATA_NU';
export const SET_EDITED_DATA_NU = 'SET_EDITED_DATA_NU';
export const NUMOFUNITS_EXTRA_STATE = 'NUMOFUNITS_EXTRA_STATE';
export const SET_CELL_FOCUSED = 'NOU_SET_CELL_FOCUSED';
export const GET_SINGLE_PAGE_CLAIM_DATA = 'NOU_GET_SINGLE_PAGE_CLAIM_DATA';
export const SET_SINGLE_PAGE_CLAIM_DATA_NU = 'NOU_SET_SINGLE_PAGE_CLAIM_DATA_NU';
export const NO_OF_UNITS_SEARCH_TAB_DATA = 'NO_OF_UNITS_SEARCH_TAB_DATA';
export const NO_ACTION_TAKEN = 'NO_ACTION_TAKEN';